export default function(event, commit, state) {
    if (event.user === state.provider.id)
		commit('provider/addProviderEvent', event)
	else
		commit('provider/addPatientEvent', event)
}
